import { AssetDto } from '@nusign/picflow-backend-types';
import { Rect } from '../../classes/rect.class';

export class GalleryItem {
  asset: AssetDto;
  dimensions = new Rect();
  bounds = new Rect();
  color: string;
  swapped?: number;

  constructor(asset: AssetDto = undefined) {
    this.asset = asset;
  }
}
